interface LongTermMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const LongTermMenu: React.FC<LongTermMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={38}
            checked={!clear && displayValue === 38}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Atrial Fibrillation
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={39}
            checked={!clear && displayValue === 39}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Atrial Flutter{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={40}
            checked={!clear && displayValue === 40}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Cardiac Arrest
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={41}
            checked={!clear && displayValue === 41}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Cardioversion</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={42}
            checked={!clear && displayValue === 42}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Dialysis</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={43}
            checked={!clear && displayValue === 43}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Heart Failure{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={44}
            checked={!clear && displayValue === 44}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Infective Endocarditis{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={45}
            checked={!clear && displayValue === 45}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Myocardial Infarction
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={46}
            checked={!clear && displayValue === 46}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Stroke</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={47}
            checked={!clear && displayValue === 47}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Syncope</span>
        </label>
      </li>
    </ul>
  );
};

export default LongTermMenu;
